export default __webpack_public_path__ + "94f61c7b19c6281a0e562d2fefcfaabd.png";